import { Card, CardContent, CardFooter, Timeline } from '@ps/sports-ui-component-library';
import type { PopularAccumulatorsConfig } from '@ps/web-sports-api-types';
import React from 'react';

import { MultipleSelections } from '@swf/sports/components/Selection/MultipleSelections';
import { useNormalisedMeetingBasedData } from '@swf/sports/hooks/useNormalisedMeetingBasedData';

import PopularAccumulatorCardHeader from '../PopularAccumulatorCardHeader/PopularAccumulatorCardHeader';

import MeetingBasedPopularAccumulatorItem from './components/MeetingBasedPopularAccumulatorItem/MeetingBasedPopularAccumulatorItem';

interface Props {
  popularAccumulator: PopularAccumulatorsConfig;
}

const MeetingBasedPopularAccumulatorCard: React.FC<Props> = ({ popularAccumulator }: Props) => {
  const { markets } = useNormalisedMeetingBasedData({
    marketId: popularAccumulator.runnerIds[0].marketId
  });

  return (
    <Card>
      <PopularAccumulatorCardHeader count={popularAccumulator.count} />
      <CardContent>
        <Timeline>
          {popularAccumulator.runnerIds.map((runnerId) => (
            <MeetingBasedPopularAccumulatorItem
              key={`${runnerId.marketId}-${runnerId.selectionId}`}
              {...runnerId}
            />
          ))}
        </Timeline>
      </CardContent>
      <CardFooter>
        <MultipleSelections
          selections={popularAccumulator.runnerIds.map((runnerId) => ({
            runnerId,
            market: markets[runnerId.marketId]
          }))}
          odds={popularAccumulator.winRunnerOdds}
        />
      </CardFooter>
    </Card>
  );
};
export default MeetingBasedPopularAccumulatorCard;
